import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CreatePasswordService } from './create-password.service';
import { ActivatedRoute } from "@angular/router";
import { filter, tap } from "rxjs";

@Component({
    selector: 'create-password',
    templateUrl: './create-password.component.html',
    providers: [CreatePasswordService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CreatePasswordComponent implements OnInit {
  email: string;
  token_url: string;

  // eslint-disable-next-line no-unused-vars
  constructor(
    private createPasswordService: CreatePasswordService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {

      this.route.queryParams.pipe(
          filter(params => params['email']),
          tap(params => {
              this.email = params['email'];
              this.create_password(params['email']);
          })
      ).subscribe();
  }

  protected create_password(email: string) {
    this.createPasswordService.create_password(email).then((data: {url: string})=> {
        this.token_url = data.url;
        // select the text in order to be able to copy it in the clipboard
        const token_url = document.querySelector('#token');
        const range = document.createRange();
        range.selectNode(token_url);
        window.getSelection().addRange(range);
    }, (errors) => {
        this.token_url = JSON.stringify(errors.error.error);
    });
  }
}